(function () {

    'use strict';

    if (typeof window === 'undefined') {

        module.exports = exportFn(
            require('../enums/dataSourceIds.js'),
            require('../enums/metricTransformIds.js'),
            require('../enums/dataSourceFilterGroupIds.js'),
            require('../../../enums/metrics.js'),
            require('../metricRequest.js'),
            require('../../../modules/data/channels.js'),
            require('../../../enums/likelyPromoted.js'),
            require('lodash'),
            require('moment')
        );

    } else {
        RivalIQ.module('metrics.new.client', function (metricsNew) {
            metricsNew.UniversalMetricConverter = exportFn(
                RivalIQ.metrics.new.enums.DataSourceIds,
                RivalIQ.metrics.new.enums.MetricTransformIds,
                RivalIQ.metrics.new.enums.DataSourceFilterGroupIds,
                RivalIQ.enums,
                RivalIQ.metrics.new.MetricRequest,
                RivalIQ.data.channels,
                RivalIQ.enums.likelyPromoted,
                window._,
                window.moment
            );
        });
    }

    function exportFn(DataSourceIds, MetricTransformIds, DataSourceFilterGroupIds, enums, MetricRequest, channels, likelyPromoted, _, moment) {

        function getSourceForOldMetric(oldMetric) {
            let source = oldMetric.source;
            if (_.isUndefined(source)) {
                source = channels.get(oldMetric.channel).get('source');
            }

            if (_.isUndefined(source)) {
                source = enums.sources.CROSS_CHANNEL;
            }

            return source;
        }

        function getFreeDimensions(metric) {
            return _.filter(metric.dimensions, (dimension) => {
                const value = _.get(metric, dimension);
                return (value === null || value === undefined);
            });
        }

        function isFreeDimension(metricOrArray, dimension) {
            const freeDimensions = (_.isArray(metricOrArray) ? metricOrArray : getFreeDimensions(metricOrArray));
            return (freeDimensions.indexOf(dimension) >= 0);
        }

        const DimensionMapping = {
            channel: 'source',
            engagement_type: 'engagementType',
            reaction_type: 'reactionType'
        };

        // TODO this and below should be replaced by lookups to /metrics.js,
        // which already knows the scope of metrics by identity (source,
        // measure, dimensions)
        const PresenceLevelMetrics = {
            name: 'audience',
            audience: 'audience',
            following: 'following',
            followers_to_following: 'followers_to_following',
            lifetime_count: 'lifetime_count',
            lifetime_likes: 'lifetime_likes',
            listed_count: 'listed_count',
            followers_count: 'followers_count',
            talking_about: 'talking_about',
            page_views: 'page_views',
            profile_views: 'profile_views',
            net_followers: 'net_followers',
            videos: 'lifetime_videos'
        };

        const PostLevelMetricExceptions = {
            count: 'distinctCount(postId)',
            all_count: 'distinctCount(postId)',
            all_avg_count_per_day: 'averagePerDay(postId)',
            avg_count_per_day: 'averagePerDay(postId)',
            all_avg_count_per_week: 'averagePerWeek(postId)',
            avg_count_per_week: 'averagePerWeek(postId)',
            avg_engagement_rate_per_post: 'averageRate(engagement_rate_by_presence_reach)',
            avg_engagement_total_per_day: 'averagePerDay(engagement_total)',
            engagement_total_per_post: 'average(engagement_total)',
            video_views_per_day: 'averagePerDay(video_views)',
            video_views_per_tweet: 'average(video_views)',
            engagement_total_tweets_and_replies: 'sum(engagement_total)',
            views: 'sum(video_views)',
            post_views: 'sum(video_views)',
            views_per_post: 'average(video_views)',
            avg_views_per_day: 'averagePerDay(video_views)',
            engagement_total_per_view: 'averageRate(engagement_rate_by_view)',
            average_comments_per_post: 'average(conversation)',
            average_likes_per_post: 'average(applause)',
            views_per_follower: 'averageRate(view_rate_by_presence_reach)'
        };

        function getMetricDetails(oldMetric) {
            const source = getSourceForOldMetric(oldMetric);

            const metricDetails = {
                source: source
            };

            // oddball special cases
            switch (oldMetric.property) {

                case 'name': {
                    metricDetails.isCompanyLevelMetric = true;
                    metricDetails.dataSourceId = DataSourceIds.COMPANIES;
                    metricDetails.measure = 'companyId';
                    return metricDetails;
                }

                case 'url':
                case 'overview':
                case 'overview_size':
                case 'display_name':
                case 'display_name_size':
                case 'title':
                case 'title_size':
                case 'keywords':
                case 'location':
                case 'overview_size_rating': {
                    metricDetails.isCompanyLevelMetric = true;
                    metricDetails.dataSourceId = DataSourceIds.COMPANIES;

                    if (source === enums.sources.WEB && oldMetric.property.startsWith('title')) {
                        metricDetails.measure = oldMetric.property
                            .replace('size', 'length')
                            .replace('title', 'website_title');
                    } else {
                        metricDetails.measure = oldMetric.property
                            .replace('size', 'length')
                            .replace('title', 'display_name');
                    }

                    metricDetails.dimensions = ['source'];
                    metricDetails.filters = {
                        [DataSourceFilterGroupIds.source]: {
                            onlySourceIds: [source]
                        }
                    };

                    return metricDetails;
                }

                case 'likely_promoted':
                    metricDetails.isPostLevelMetric = true;
                    metricDetails.dataSourceId = DataSourceIds.FACEBOOK_PUBLIC_POST_DATA;

                    metricDetails.measure = 'distinctCount(postId)';
                    metricDetails.filters = {
                        publicPost: {
                            promotedPosts: [likelyPromoted.values.likelyPromoted]
                        }
                    };
                    return metricDetails;

                default:
                    // fall through
            }

            metricDetails.isCompanyLevelMetric = false;
            metricDetails.isPresenceLevelMetric = Boolean(PresenceLevelMetrics[oldMetric.property]);
            metricDetails.isPostLevelMetric = !metricDetails.isPresenceLevelMetric;

            const sourceDetails = enums.sourceDetails[source];
            const sourcePrivacy = (sourceDetails.privateData ? 'PRIVATE' : 'PUBLIC');
            let sourceName = _.snakeCase(sourceDetails.name.toUpperCase()).toUpperCase();
            if (source === enums.sources.TIKTOK || source === enums.sources.TIKTOK_INSIGHTS) {
                sourceName = 'TIKTOK';
            }

            metricDetails.dataSourceId = metricDetails.isPresenceLevelMetric ?
                `${sourceName}_${sourcePrivacy}_PRESENCE_DATA` :
                `${sourceName}_${sourcePrivacy}_POST_DATA`;

            if (metricDetails.isPresenceLevelMetric) {
                metricDetails.measure = PresenceLevelMetrics[oldMetric.property];
            } else {
                if (PostLevelMetricExceptions[oldMetric.property]) {
                    metricDetails.measure = PostLevelMetricExceptions[oldMetric.property];
                } else if (_.includes(oldMetric.dimensions, 'reaction_type') && oldMetric.reaction_type) {
                    switch (oldMetric.property) {
                        case 'engagement_total':
                            metricDetails.measure = `sum(${oldMetric.reaction_type})`;
                            break;

                        case 'avg_engagement_total_per_day':
                            metricDetails.measure = `averagePerDay(${oldMetric.reaction_type})`;
                            break;

                        default:
                            throw new Error(`Don't know how to handle ${oldMetric.property}`);
                    }
                } else if (_.includes(oldMetric.dimensions, 'engagement_type') && oldMetric.engagement_type) {
                    switch (oldMetric.property) {
                        case 'engagement_total':
                            metricDetails.measure = `sum(${oldMetric.engagement_type})`;
                            break;

                        case 'avg_engagement_total_per_day':
                            metricDetails.measure = `averagePerDay(${oldMetric.engagement_type})`;
                            break;

                        default:
                            throw new Error(`Don't know how to handle ${oldMetric.property}`);
                    }
                } else {
                    metricDetails.measure = `sum(${oldMetric.property})`;
                }
            }

            return metricDetails;
        }

        function toISOString(date, timezone) {
            const tzDate = moment.utc(date).tz(timezone, true);
            return tzDate.toISOString();
        }

        function timeAnalysisModeHandler(timeAnalysisMode, oldMetric, newMetric) {
            let config = null;
            const timezone = oldMetric.timezone;

            if (timeAnalysisMode === enums.timeAnalysisMode.MAIN_PERIOD) {
                config = {
                    dimensionReductions: [
                        {
                            day: 'sum'
                        }
                    ],
                    filters: {
                        timePeriod: {
                            startDate: toISOString(oldMetric.timePeriod.mainPeriodStart, timezone),
                            endDate: toISOString(oldMetric.timePeriod.mainPeriodEnd, timezone)
                        }
                    }
                };
            } else if (timeAnalysisMode === enums.timeAnalysisMode.COMPARE_PERIOD) {
                config = {
                    dimensionReductions: [
                        {
                            day: 'sum'
                        }
                    ],
                    filters: {
                        timePeriod: {
                            startDate: toISOString(oldMetric.timePeriod.comparePeriodStart, timezone),
                            endDate: toISOString(oldMetric.timePeriod.comparePeriodEnd, timezone)
                        }
                    }
                };
            } else if (timeAnalysisMode === enums.timeAnalysisMode.DELTA_RELATIVE) {
                config = {
                    dimensionReductions: [
                        {
                            day: 'sum'
                        }
                    ],
                    filters: {
                        timePeriod: {
                            startDate: toISOString(oldMetric.timePeriod.mainPeriodStart, timezone),
                            endDate: toISOString(oldMetric.timePeriod.mainPeriodEnd, timezone)
                        }
                    },
                    measure: {
                        transform: 'deltaRelative',
                        transformConfig: {
                            comparePeriodStartDate: toISOString(oldMetric.timePeriod.comparePeriodStart, timezone),
                            comparePeriodEndDate: toISOString(oldMetric.timePeriod.comparePeriodEnd, timezone)
                        }
                    }
                };
            } else if (timeAnalysisMode === enums.timeAnalysisMode.DELTA_ABSOLUTE) {
                config = {
                    dimensionReductions: [
                        {
                            day: 'sum'
                        }
                    ],
                    filters: {
                        timePeriod: {
                            startDate: toISOString(oldMetric.timePeriod.mainPeriodStart, timezone),
                            endDate: toISOString(oldMetric.timePeriod.mainPeriodEnd, timezone)
                        }
                    },
                    measure: {
                        transform: 'deltaAbsolute',
                        transformConfig: {
                            comparePeriodStartDate: toISOString(oldMetric.timePeriod.comparePeriodStart, timezone),
                            comparePeriodEndDate: toISOString(oldMetric.timePeriod.comparePeriodEnd, timezone)
                        }
                    }
                };
            } else if (timeAnalysisMode === enums.timeAnalysisMode.DAILY_VALUES) {
                config = {
                    dimensions: ['companyId', 'day'],
                    dimensionReductions: [],
                    filters: {
                        timePeriod: {
                            startDate: toISOString(oldMetric.timePeriod.mainPeriodStart, timezone),
                            endDate: toISOString(oldMetric.timePeriod.mainPeriodEnd, timezone)
                        }
                    }
                };
            }

            return _.merge({}, newMetric, config);
        }

        function tiktokPostMetricTransformer(oldMetric) {
            const metricDetails = getMetricDetails(oldMetric);
            const startDate = toISOString(oldMetric.timePeriod.mainPeriodStart, oldMetric.timezone);
            const endDate = toISOString(oldMetric.timePeriod.mainPeriodEnd, oldMetric.timezone);

            const newMetric = {
                dataSourceId: metricDetails.dataSourceId,
                dimensions: [`post_id`],
                dimensionReductions: [],
                measure: {
                    field: oldMetric.property
                },
                filters: {
                    company: {
                        landscapeId: oldMetric.landscapeId
                    },
                    timePeriod: {
                        startDate,
                        endDate,
                        timezone: oldMetric.timezone
                    },
                    ordering: {
                        sort: [
                            {
                                dataSourceId: metricDetails.dataSourceId,
                                dimensions: [`post_id`],
                                measure: oldMetric.orderBy,
                                filters: {
                                    company: {
                                        landscapeId: oldMetric.landscapeId
                                    },
                                    timePeriod: {
                                        startDate,
                                        endDate,
                                        timezone: oldMetric.timezone
                                    }
                                },
                                sortOrder: (oldMetric.sortOrder === 1 ? `desc` : `asc`)
                            }
                        ]
                    },
                    publicPost: {
                        promotedPosts: [`likelyPromoted`, `notLikelyPromoted`],
                        minDistinctCompanyIds: 0,
                        minDistinctPostIds: 0,
                        postTagConjunction: oldMetric.postTagConjunction,
                        postTagExclude: oldMetric.postTagExclude,
                        elideZeroPostsCompanies: false
                    }
                }
            };

            if (oldMetric.searchTerm) {
                newMetric.filters.publicPost.searchTerm = oldMetric.searchTerm;
                _.set(newMetric.filters.ordering.sort[0].filters, ['publicPost', 'searchTerm'], oldMetric.searchTerm);
            }

            if (oldMetric.mediaTypeFilter) {
                newMetric.filters.publicPost.mediaTypes = [oldMetric.mediaTypeFilter];
                _.set(newMetric.filters.ordering.sort[0].filters, ['publicPost', 'mediaTypes'], [oldMetric.mediaTypeFilter]);
            }

            if (oldMetric.limit > 0) {
                newMetric.filters.ordering.limit = oldMetric.limit;
            }

            return newMetric;
        }

        const TIKTOK_PRESENCE_MEASURE_MAP = {
            'comments_insights': 'comments',
            'likes_insights': 'likes',
            'shares_insights': 'shares',
            'engagement_total_insights': 'engagement_total',
            'video_views_insights': 'video_views'
        };

        function tiktokPresenceMetricTransformer(oldMetric) {
            const field = _.get(TIKTOK_PRESENCE_MEASURE_MAP, oldMetric.property, oldMetric.property);

            const newMetric = {
                // NOTE sometimes the `getMetricDetails` method returns the
                // wrong `dataSourceId`, so we're just going to hardcode it for
                // TikTok Insights metrics
                dataSourceId: DataSourceIds.TIKTOK_PRIVATE_PRESENCE_DATA,
                dimensions: ['companyId'],
                dimensionReductions: [],
                filters: {
                    company: {
                        landscapeId: oldMetric.landscapeId
                    },
                    timePeriod: {
                        timezone: oldMetric.timezone
                    }
                },
                measure: {
                    field: field
                }
            };

            const freeDimensions = getFreeDimensions(oldMetric);
            if (oldMetric.benchmarkCompaniesFilter) {
                newMetric.measure.transformConfig = {
                    reducer: oldMetric.companyIdAggregate,
                    benchmarkCompaniesFilter: oldMetric.benchmarkCompaniesFilter
                };

                switch (oldMetric.timeAnalysisMode) {
                    case enums.timeAnalysisMode.DELTA_RELATIVE:
                        newMetric.measure.transformConfig.transform = MetricTransformIds.companiesBenchmarkDeltaRelative;
                        break;
                    case enums.timeAnalysisMode.DELTA_ABSOLUTE:
                        newMetric.measure.transformConfig.transform = MetricTransformIds.companiesBenchmarkDeltaAbsolute;
                        break;
                    default:
                        newMetric.measure.transformConfig.transform = MetricTransformIds.companiesBenchmark;
                        break;
                }
            } else {
                if (!isFreeDimension(freeDimensions, 'companyId')) {
                    newMetric.filters.company.onlyCompanyIds = [oldMetric.companyId];
                }

                if (isFreeDimension(freeDimensions, 'timeAnalysisMode')) {
                    return _.map([
                        enums.timeAnalysisMode.MAIN_PERIOD,
                        enums.timeAnalysisMode.DELTA_RELATIVE,
                        enums.timeAnalysisMode.COMPARE_PERIOD,
                        enums.timeAnalysisMode.DELTA_ABSOLUTE,
                        enums.timeAnalysisMode.DAILY_VALUES
                    ], (timeAnalysisMode) => {
                        const req = timeAnalysisModeHandler(timeAnalysisMode, oldMetric, newMetric);
                        // NOTE we need to this to correctly handle the
                        // dimensions when adjusting the data below
                        req.metricResultTransformer = {
                            timeAnalysisMode: timeAnalysisMode
                        };
                        return req;
                    });
                }
            }

            const group = _.reduce(freeDimensions, (memo, dimension) => {
                if (!memo && ['day', 'week', 'month'].indexOf(dimension) >= 0) {
                    return dimension;
                }
                return memo;
            }, null);

            if (!group || group !== 'day') {
                newMetric.dimensionReductions.push({
                    day: 'sum'
                });
            }

            if (group) {
                newMetric.dimensions.push(group);
            }

            newMetric.filters.timePeriod = {
                startDate: toISOString(oldMetric.timePeriod.mainPeriodStart, oldMetric.timezone),
                endDate: toISOString(oldMetric.timePeriod.mainPeriodEnd, oldMetric.timezone)
            };

            return newMetric;
        }

        const NEW_METRIC_TRANSFORMER = {
            [enums.sources.TIKTOK_INSIGHTS]: {
                'profile_views': tiktokPresenceMetricTransformer,
                'comments_insights': tiktokPresenceMetricTransformer,
                'likes_insights': tiktokPresenceMetricTransformer,
                'shares_insights': tiktokPresenceMetricTransformer,
                'engagement_total_insights': tiktokPresenceMetricTransformer,
                'video_views_insights': tiktokPresenceMetricTransformer,

                // post metric handling
                'comments': {
                    'post': tiktokPostMetricTransformer
                },
                'engagement_rate_by_impression': {
                    'post': tiktokPostMetricTransformer
                },
                'engagement_rate_by_presence_reach': {
                    'post': tiktokPostMetricTransformer
                },
                'engagement_total': {
                    'post': tiktokPostMetricTransformer
                },
                'impressions': {
                    'post': tiktokPostMetricTransformer
                },
                'likes': {
                    'post': tiktokPostMetricTransformer
                },
                'media_type': {
                    'post': tiktokPostMetricTransformer
                },
                'post': {
                    'post': tiktokPostMetricTransformer
                },
                'presence_reach': {
                    'post': tiktokPostMetricTransformer
                },
                'published_at': {
                    'post': tiktokPostMetricTransformer
                },
                'shares': {
                    'post': tiktokPostMetricTransformer
                },
                'video_views': {
                    'post': tiktokPostMetricTransformer
                }
            }
        };

        function convertToNewMetricRequest(oldMetric) {
            // TODO this function is fraught, and since time's up on the product,
            // we are going to just completely short circuit the logic so that
            // we can somewhat manually (but possibly more generally) expand an
            // old metric into a new one (first, and likely only, for TikTok
            // Insights)
            const transformerPath = [oldMetric.source, oldMetric.property];
            // NOTE only if we are dealing with posts should we add the
            // dimension to the transformer path to minimize collisions between
            // presence and post level handling
            if (isFreeDimension(oldMetric, `post`)) {
                transformerPath.push(`post`);
            }

            const transformer = _.get(NEW_METRIC_TRANSFORMER, transformerPath);
            if (_.isFunction(transformer)) {
                return transformer(oldMetric);
            }

            const metricDetails = getMetricDetails(oldMetric);

            const newMetric = {
                dataSourceId: metricDetails.dataSourceId,
                filters: {
                    company: {
                        landscapeId: oldMetric.landscapeId,
                        companyFilter: oldMetric.companySetDescriptor,
                        focusCompanyId: oldMetric.focusCompanyId
                    }
                }
            };

            if (oldMetric.onlyCompanySetIds) {
                if (_.isString(oldMetric.onlyCompanySetIds)) {
                    newMetric.filters.company.onlyCompanySetIds = _.map(oldMetric.onlyCompanySetIds.split(','), Number);
                } else {
                    newMetric.filters.company.onlyCompanySetIds = oldMetric.onlyCompanySetIds;
                }
            }

            newMetric.dimensions = _.reduce(oldMetric.dimensions, (memo, dimension) => {
                if (_.isUndefined(oldMetric[dimension])) {
                    memo.push(DimensionMapping[dimension] || dimension);
                }

                return memo;
            }, []);
            newMetric.dimensions = _.union(newMetric.dimensions, metricDetails.dimensions);

            newMetric.measure = metricDetails.measure;

            if (!_.includes(newMetric.dimensions, 'companyId')) {
                if (oldMetric.benchmarkCompaniesFilter && _.without(newMetric.dimensions, 'day', 'week', 'month').length === 0) {
                    // we're aggregating by only day/week/month and have no companyId dimension, this is a benchmark metric.
                    if (_.isString(newMetric.measure)) {
                        newMetric.measure = {
                            field: `${newMetric.measure}`
                        };
                    }

                    _.extend(newMetric.measure, {
                        transformConfig: {
                            reducer: oldMetric.companyIdAggregate,
                            benchmarkCompaniesFilter: oldMetric.benchmarkCompaniesFilter
                        }
                    });

                    switch (oldMetric.timeAnalysisMode) {
                        case enums.timeAnalysisMode.DELTA_RELATIVE:
                            newMetric.measure.transformConfig.transform = MetricTransformIds.companiesBenchmarkDeltaRelative;
                            break;

                        case enums.timeAnalysisMode.DELTA_ABSOLUTE:
                            newMetric.measure.transformConfig.transform = MetricTransformIds.companiesBenchmarkDeltaAbsolute;
                            break;

                        case enums.timeAnalysisMode.MAIN_PERIOD:
                        default:
                            newMetric.measure.transformConfig.transform = MetricTransformIds.companiesBenchmark;
                            break;
                    }
                } else {
                    newMetric.dimensionReductions = [{
                        companyId: oldMetric.companyIdAggregate
                    }];
                }
            }

            if (!metricDetails.isCompanyLevelMetric) {

                if (oldMetric.timeAnalysisMode === enums.timeAnalysisMode.COMPARE_PERIOD) {
                    // Delta Relative and Delta Absolute are supported by transformConfig in the `if` condition below (!oldMetric.benchmarkCompaniesFilter)
                    newMetric.filters.timePeriod = {
                        startDate: oldMetric.timePeriod.comparePeriodStart,
                        endDate: oldMetric.timePeriod.comparePeriodEnd,
                        timezone: oldMetric.timezone
                    };
                } else {
                    newMetric.filters.timePeriod = {
                        startDate: oldMetric.timePeriod.mainPeriodStart,
                        endDate: oldMetric.timePeriod.mainPeriodEnd,
                        timezone: oldMetric.timezone
                    };
                }

                if (!oldMetric.benchmarkCompaniesFilter) {
                    if (_.includes([enums.timeAnalysisMode.DELTA_RELATIVE, enums.timeAnalysisMode.DELTA_ABSOLUTE], oldMetric.timeAnalysisMode)) {
                        if (_.isString(newMetric.measure)) {
                            newMetric.measure = {
                                field: `${newMetric.measure}`
                            };
                        }
                        newMetric.measure.transformConfig = {
                            comparePeriodStartDate: oldMetric.timePeriod.comparePeriodStart,
                            comparePeriodEndDate: oldMetric.timePeriod.comparePeriodEnd
                        };

                        if (oldMetric.timeAnalysisMode === enums.timeAnalysisMode.DELTA_RELATIVE) {
                            newMetric.measure.transform = MetricTransformIds.deltaRelative;
                        } else if (oldMetric.timeAnalysisMode === enums.timeAnalysisMode.DELTA_ABSOLUTE) {
                            newMetric.measure.transform = MetricTransformIds.deltaAbsolute;
                        }
                    }
                }
            }

            if (metricDetails.isPresenceLevelMetric && metricDetails.source === enums.sources.CROSS_CHANNEL && !_.includes(newMetric.dimensions, 'source')) {
                newMetric.dimensionReductions = newMetric.dimensionReductions || [];
                newMetric.dimensionReductions.push({
                    source: 'sum'
                });
            }

            if (metricDetails.isPresenceLevelMetric && !_.includes(newMetric.dimensions, 'day')) {
                newMetric.dimensionReductions = newMetric.dimensionReductions || [];
                newMetric.dimensionReductions.push({
                    day: 'latestNonNull'
                });
            }

            if (oldMetric.over && oldMetric[`${oldMetric.over}Aggregate`]) {
                newMetric.dimensionReductions.push({
                    [oldMetric.over]: oldMetric[`${oldMetric.over}Aggregate`]
                });
            }

            if (metricDetails.isPostLevelMetric) {
                newMetric.filters.publicPost = _.omitBy({
                    postIds: oldMetric.postIds,
                    searchTerm: oldMetric.searchTerm,
                    canonicalUrlFilter: oldMetric.canonicalUrlFilter,
                    canonicalUrlExactMatch: oldMetric.canonicalUrlExactMatch,
                    primaryDomainFilter: oldMetric.primaryDomainFilter,
                    postTagConjunction: oldMetric.postTagConjunction,
                    postTagExclude: oldMetric.postTagExclude
                }, _.isUndefined);

                if (_.includes([enums.sources.CROSS_CHANNEL, enums.sources.TWITTER], metricDetails.source)) {
                    if (oldMetric.property === 'engagement_total_tweets_and_replies') {
                        newMetric.filters.publicPost.tweetTypes = ['normal', 'reply'];
                    } else if (oldMetric.tweetType) {
                        newMetric.filters.publicPost.tweetTypes = [oldMetric.tweetType];
                    } else if (_.includes(['all_count', 'all_avg_count_per_day', 'all_avg_count_per_week'], oldMetric.property)) {
                        newMetric.filters.publicPost.tweetTypes = ['normal', 'reply', 'retweet'];
                    } else {
                        newMetric.filters.publicPost.tweetTypes = ['normal'];
                    }

                    if (oldMetric.property === 'video_views_per_tweet') {
                        newMetric.filters.publicPost.mediaTypes = ['video'];
                    }
                }
            }

            _.each(metricDetails.filters, (filter, filterName) => {
                newMetric.filters[filterName] = _.extend({}, newMetric.filters[filterName], filter);
            });

            return newMetric;
        }

        const FREE_DIMENSION_IDX = {
            companyId: 0,
            week: 1,
            day: 1,
            month: 1,
            timeAnalysisMode: null
        };

        function tiktokPostMetricResultTransformer(oldMetric, results, requests) {
            const data = _.first(results).data;
            return data;
        }

        function tiktokPresenceMetricResultTransformer(oldMetric, results, requests) {
            const freeDimensions = getFreeDimensions(oldMetric);
            return _.reduce(results, (memo, result, idx) => {
                return memo.concat(
                    _.map(result.data, (datum) => {
                        return _.map(freeDimensions, (dimension) => {
                            const dimensionIdx = FREE_DIMENSION_IDX[dimension];
                            if (dimensionIdx === undefined) {
                                throw new Error(`invalid free dimension ${dimension}`);
                            }
                            const value = _.get(requests[idx], ['metricResultTransformer', dimension], datum[dimensionIdx]);
                            return value;
                        }).concat(_.last(datum));
                    })
                );
            }, []);
        }

        const NEW_METRIC_RESULT_TRANSFORMER = {
            [enums.sources.TIKTOK_INSIGHTS]: {
                'profile_views': tiktokPresenceMetricResultTransformer,
                'comments_insights': tiktokPresenceMetricResultTransformer,
                'likes_insights': tiktokPresenceMetricResultTransformer,
                'shares_insights': tiktokPresenceMetricResultTransformer,
                'engagement_total_insights': tiktokPresenceMetricResultTransformer,
                'video_views_insights': tiktokPresenceMetricResultTransformer,

                // post metric handling
                'comments': {
                    'post': tiktokPostMetricResultTransformer
                },
                'engagement_rate_by_impression': {
                    'post': tiktokPostMetricResultTransformer
                },
                'engagement_rate_by_presence_reach': {
                    'post': tiktokPostMetricResultTransformer
                },
                'engagement_total': {
                    'post': tiktokPostMetricResultTransformer
                },
                'impressions': {
                    'post': tiktokPostMetricResultTransformer
                },
                'likes': {
                    'post': tiktokPostMetricResultTransformer
                },
                'media_type': {
                    'post': tiktokPostMetricResultTransformer
                },
                'post': {
                    'post': tiktokPostMetricResultTransformer
                },
                'presence_reach': {
                    'post': tiktokPostMetricResultTransformer
                },
                'published_at': {
                    'post': tiktokPostMetricResultTransformer
                },
                'shares': {
                    'post': tiktokPostMetricResultTransformer
                },
                'video_views': {
                    'post': tiktokPostMetricResultTransformer
                }
            }
        };

        function convertToOldMetricData(oldMetricRequest, newMetricResult, newMetricRequest) {
            const metricDetails = getMetricDetails(oldMetricRequest);

            const transformPath = [metricDetails.source, oldMetricRequest.property];
            if (isFreeDimension(oldMetricRequest, 'post')) {
                transformPath.push('post');
            }

            const transformer = _.get(NEW_METRIC_RESULT_TRANSFORMER, transformPath);
            if (_.isFunction(transformer)) {
                return transformer(oldMetricRequest, newMetricResult, newMetricRequest);
            }

            let data = (_.isArray(newMetricResult) ? _.first(newMetricResult) : newMetricResult).data;
            if (metricDetails.isCompanyLevelMetric && _.isEqual(metricDetails.dimensions, ['source'])) {
                const indexOfSourceDimension = _.indexOf(newMetricResult.dimensions, 'source');
                data = _.map(data, row => {
                    row = _.clone(row);
                    row.splice(indexOfSourceDimension, 1);
                    return row;
                });
            }

            return data;
        }

        function shouldUseNewMetric(oldMetricRequest) {
            return (oldMetricRequest.dimensions.includes('companySetId') || oldMetricRequest.over === 'companySetId');
        }

        return {
            shouldUseNewMetric,
            convertToNewMetricRequest,
            convertToOldMetricData
        };
    }
})();
